export const TAG_HASHTAG_POSTFIX = "::tag";